import { render, staticRenderFns } from "./EmployeeRoles.vue?vue&type=template&id=27e8de0e&"
import script from "./EmployeeRoles.vue?vue&type=script&lang=js&"
export * from "./EmployeeRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports